//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import getRecommendConsultant from '@/common/consultant/recommend_consultant'
import { openChat } from '@/data/im'
export default {
    computed: {
        link () {
            return '/building/planar_graph/main?building_id=' + this.building_id
        }
    },
    props: {
        url: String,
        show_consult: Boolean,
        building_id: [String, Number],
        new_planar_graph_hint: Boolean
    },
    methods: {
        async consult () {
            // this.$bindLogEvt('planar-graph')
            const consultant = await getRecommendConsultant({
                scene: 'building_detail_planar_graph',
                building_id: this.building_id
            })
            openChat(consultant.id, {
                building_id: this.building_id
            })
        },
        sendLog(){
            this.$sendCtmEvtLog('楼盘详情-功能模块-楼盘总平图点击', {building_id: this.building_id})
        }
    }
}
